import Vue from 'vue'
import VueI18n from 'vue-i18n'
import {getPreferredLanguageFromCookie} from "@/util/locale";
// import { defaultLanguage } from '@/config'

Vue.use(VueI18n)

let messages = {}
messages["en"] = require(`@/locales/en-GB.json`)
messages["ar"] = require(`@/locales/ar-EG.json`)
messages["fr"] = require(`@/locales/fr-FR.json`)

export default new VueI18n({
  fallbackLocale: process.env.VUE_APP_DEFAULT_LANGUAGE,
  locale: getPreferredLanguageFromCookie(),
  messages
})

// function loadLocaleMessages () {
//   const locales = require.context('./locales', true, /[A-Za-z0-9-_,\s]+\.json$/i)
//   const messages = {}
//   locales.keys().forEach(key => {
//     const matched = key.match(/([a-z0-9]+)\./i)
//     if (matched && matched.length > 1) {
//       const locale = matched[1]
//       messages[locale] = locales(key)
//     }
//   })
//   return messages
// }

// export default new VueI18n({
//   locale: process.env.VUE_APP_I18N_LOCALE || 'en',
//   fallbackLocale: process.env.VUE_APP_I18N_FALLBACK_LOCALE || 'en',
//   messages: loadLocaleMessages()
// })
